export default function DirectoryPage({
  directories,
  addDirectory,
  updateDirectory,
  saveDirectory,
  removeDirectory
}) {
  return (
    <div>
      <h1>Справочник</h1>

      <div className="template-toolbar">
        <button onClick={addDirectory}>
          Создать столбец
        </button>
      </div>

      <div className="directory-list">
        {directories.map((directory) => (
          <div className="directory-card" key={directory.id}>
            <div className="directory-header">
              <input
                value={directory.name}
                onChange={(e) =>
                  updateDirectory(directory.id, "name", e.target.value)
                }
                placeholder="Название столбца"
              />

              <button
                className="save-directory-btn"
                onClick={() => saveDirectory(directory.id)}
              >
                Сохранить
              </button>

              <button
                className="remove-column-btn"
                onClick={() => removeDirectory(directory.id)}
              >
                Удалить
              </button>
            </div>

            <div className="directory-status">
              {directory.saved ? "Сохранен" : "Не сохранен"}
            </div>

            <textarea
              value={directory.values}
              onChange={(e) =>
                updateDirectory(directory.id, "values", e.target.value)
              }
              placeholder="Введите данные построчно"
              rows={6}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
